<template>
  <ScCard class="contact-card">
    <template #header>
      <div class="header">
        <div
          class="title"
        >
          {{ $t('account.sellerContact', { value: index }) }}
        </div>
        <div
          v-if="editable"
          class="edit-container"
          @click="onEdit"
        >
          <span class="text">
            {{ $t('account.edit') }}
          </span>
          <GIcon
            name="edit"
            stroke="var(--dark-grey-500)"
            size="14px"
            class="edit-icon"
          />
        </div>
      </div>
    </template>
    <template #body>
      <div class="texts-wrapper">
        <div
          class="texts"
          v-for="(key, objectIndex) in objectKeys"
          :key="objectIndex"
        >
          <span class="title">
            {{ $t(`account.${key}`) }}
          </span>
          <span class="content">
            {{ contact[key] || '---' }}
          </span>
        </div>
      </div>
    </template>
  </ScCard>
</template>

<script>
import ScCard from '@trendyol/sc-ui-kit/ScCard';
import GIcon from '@trendyol-js/grace/core/GIcon';

export default {
  name: 'SellerContactCard',
  components: { ScCard, GIcon },
  props: {
    contact: {
      type: Object,
      default: () => ({
        contactTypeName: '',
        fullName: '',
        email: '',
        phone: '',
        createDate: '',
        description: '',
      }),
    },
    index: {
      type: Number,
      default: 1,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    objectKeys () {
      return Object.keys(this.contact);
    },
  },
  methods: {
    onEdit () {
      this.$emit('edit', this.contact);
    },
  },
};
</script>
<style scoped lang="scss">
  .contact-card{
    margin: 10px;

    ::v-deep .sc-card{
      border: 1px solid #d5d9e1;
      box-shadow: none !important;
      height: 100%;

      .sc-card-header{
        background-color: #f1f2f7;
        padding: 15px 20px !important;
        border-bottom: 1px solid #d5d9e1;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          div.title{
            color: #95a1b5;
            font-size: 14px;
            font-weight: 500;
            display: flex;
          }
          .edit-container{
            display: flex;
            align-items: center;
            cursor: pointer;
            .edit-icon{
              margin-left: 10px;
            }
            .text{
              font-size: 14px;
              color: #6e7787;
            }
          }
        }

      }
      .sc-card-body{
        padding: 20px !important;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        .texts{
          display: flex;
          align-items: center;
          font-size: 14px;
          &:not(:first-child){
            margin-top: 10px;
          }
          .title{
            min-width: 65px;
            color: #495057;
            flex: 0 0 30%;
            position: relative;

            &:after {
              content: ':';
              position: absolute;
              right: 0;
            }
          }
          .content{
            flex: 1;
            font-weight: 300;
            margin-left: 19px;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #495057;
          }
        }
      }
    }
  }
</style>
